var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":""}},[_c('v-card-text',[_c('p',{staticClass:"mb-0 text-center"},[_vm._t("default"),(_vm.icon)?_c('v-icon',{staticClass:"ml-1",attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e()],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }